import React from 'react'
import Loadable from 'Components/LoadableToImported'
import { connect } from 'react-redux'
import Spinner from 'Components/Spinner'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'

const loading = () => (
  <div style={{ width: '100%', height: '350px' }}>
    <Spinner />
  </div>
)

export const SimpleChartsV2 = Loadable({
  loader: () => import(/* webpackChunkName: "SimpleChartsV2" */ './SimpleChartsV2'),
  loading,
  chunkName: 'SimpleChartsV2',
})

export default connect((state) => ({
  mobileBrowser: state.app.mobileBrowser,
  isMobile: state.app.isMobile,
}), {
})(SimpleChartsV2)

export const BuildingChartsV2 = connect((state) => ({
  mobileBrowser: state.app.mobileBrowser,
  isMobile: state.app.isMobile,
}), {
  googleAnalyticsEvent,
})(SimpleChartsV2)


// Maintenance Charts /////////////////////////////////////////////////
export const MaintChartV2 = Loadable({
  loader: () => import(/* webpackChunkName: "MaintChartV2" */ './MaintChartV2'),
  loading,
  chunkName: 'MaintChartV2',
})

export const MaintenanceChartsV2 = connect((state) => ({
  mobileBrowser: state.app.mobileBrowser,
  isMobile: state.app.isMobile,
}), {
  googleAnalyticsEvent,
})(MaintChartV2)


// Bars And Line Chart /////////////////////////////////////////////////
export const BarsAndLineChart = Loadable({
  loader: () => import(/* webpackChunkName: "BarsAndLineChart" */ './BarsAndLineChart'),
  loading,
  chunkName: 'BarsAndLineChart',
})

export const MarketReportChart = connect(state => ({
  mobileBrowser: state.app.mobileBrowser,
  isMobile: state.app.isMobile,
}),
{
})(BarsAndLineChart)
